<div class="container-fluid p-d-flex p-d-xl-none p-ai-center p-p-2 p-shadow-1 fixed-header fundo-branco">
    <div class="container">
        <div class="p-d-flex p-jc-between">
            <div>
                <img class="togglemobilemenu hamburger" (click)="ocultarExibicaoMenuLateral()" src="/assets/img/harmburger.svg"
                    alt="Abertura do menu do site" pTooltip="Abrir o menu" tooltipPosition="right" height="40px">
            </div>
            <div>
                <a routerLink="/">
                    <img class="logo" src="/assets/img/logo-jfrn-pequena.svg" alt="Logotipo da Justiça Federal do Rio Grande do Norte" height="40px">
                </a>
            </div>
        </div>

        <div class="headermenucontent" [class.visivel]="menuLateralVisivel">
            <div class="p-grid p-fluid p-ai-start">
                <div class="p-col-12">
                    <i (click)="ocultarExibicaoMenuLateral()" class="pi pi-times-circle p-mt-2" style="font-size: 2rem;"
                        pTooltip="Fechar menu" tooltopPosition="right"></i>
                </div>
                <div class="p-col-12">
                    <ul>
                        <li class="p-p-2"><a routerLink="/" (click)="ocultarExibicaoMenuLateral()">INÍCIO</a></li>
                        <li class="p-p-2"><a routerLink="/institucional" (click)="ocultarExibicaoMenuLateral()">INSTITUCIONAL</a></li>
                        <li class="p-p-2"><a routerLink="/administracao" (click)="ocultarExibicaoMenuLateral()">ADMINISTRAÇÃO</a></li>
                        <li class="p-p-2"><a routerLink="/processos-fisicos" (click)="ocultarExibicaoMenuLateral()">PROCESSOS</a></li>
                        <li class="p-p-2"><a routerLink="/juizados-especiais" (click)="ocultarExibicaoMenuLateral()">JUIZADOS ESPECIAIS</a></li>
                        <li class="p-p-2"><a [href]=rotaTurmaRecursal (click)="ocultarExibicaoMenuLateral()">TURMA RECURSAL</a></li>
                        <li class="p-p-2"><a routerLink="/varas-federais" (click)="ocultarExibicaoMenuLateral()">VARAS FEDERAIS</a></li>
                        <li class="p-p-2"><a routerLink="/transparencia" (click)="ocultarExibicaoMenuLateral()">TRANSPARÊNCIA</a></li>
                        <li class="p-p-2"><a routerLink="/imprensa" (click)="ocultarExibicaoMenuLateral()">IMPRENSA</a></li>
                    </ul>
                </div>
                <div class="p-col-12">
                    <hr>
                </div>
                <div class="p-col-12">
                    <div class="p-grid p-p-0 p-text-center">
                        <a class="p-col font-size-1 text-color-white text-decoration-none" href="{{pathFormularioSIC.caminho}}"
                            pTooltip="Acessar página do SIC/Ouvidoria" tooltipPosition="bottom" style="line-height: normal;" target="_blank"
                            (click)="ocultarExibicaoMenuLateral()">
                            <fa-icon [icon]="faEnvelopeOpen" class="fa-2x text-color-white p-d-block"></fa-icon>
                            SIC/ <br> Ouvidoria
                        </a>
                        <!-- <a class="p-col font-size-1 text-color-white text-decoration-none" routerLink="{{pathCanaisAtendimento.caminho + '/' + pathCentralDeAtendimento.caminho}}"
                            pTooltip="Acessar página da central de atendimento" tooltipPosition="bottom" style="line-height: normal;"
                            (click)="ocultarExibicaoMenuLateral()">
                            <fa-icon [icon]="faHeadset" class="fa-2x text-color-white p-d-block"></fa-icon>
                            Central de<br>Atendimento
                        </a> -->
                        <a class="p-col font-size-1 text-color-white text-decoration-none" routerLink="{{pathCanaisAtendimento.caminho + '/' + pathBalcao.caminho}}"
                            pTooltip="Acessar página do balcão virtual" tooltipPosition="bottom" style="line-height: normal;"
                            (click)="ocultarExibicaoMenuLateral()">
                            <fa-icon [icon]="faChalkboardTeacher" class="fa-2x text-color-white p-d-block"></fa-icon>
                            Balcão <br>Virtual
                        </a>
                    </div>
                </div>

                <!--<div class="p-col-12">
                    <div class="p-inputgroup">
                        <input type="text" class="w-100" pInputText placeholder="Pesquisar por">
                        <span class="p-inputgroup-addon"><i class="pi pi-search"></i></span>
                    </div>
                </div>-->
            </div>
        </div>
    </div>
</div>

<div class="p-d-flex p-d-xl-none" style="height: 64px;"></div>
